var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrendingDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2335 11.4332L12.1935 10.4732L8.94015 7.21982L6.74682 9.41315C6.48682 9.67315 6.06682 9.67315 5.80682 9.41315L1.80682 5.40648C1.54682 5.14648 1.54682 4.72648 1.80682 4.46648C2.06682 4.20648 2.48682 4.20648 2.74682 4.46648L6.27348 7.99982L8.46682 5.80648C8.72682 5.54648 9.14682 5.54648 9.40682 5.80648L13.1335 9.52648L14.0935 8.56648C14.3001 8.35982 14.6602 8.50648 14.6602 8.79982V11.6598C14.6602 11.8465 14.5135 11.9932 14.3268 11.9932H11.4668C11.1735 11.9998 11.0268 11.6398 11.2335 11.4332Z",
    fill: "#F44D2C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingDown);
export default __webpack_public_path__ + "static/media/Trending-down.55a19b98b0ec0caeb20da71a01c5d9a6.svg";
export { ForwardRef as ReactComponent };